import { ModeToggle } from '@/components/mode-toggle';
import { ReactFlowProvider } from 'reactflow';
import { SchemaCanvas } from '@/components/visual-schema/schema-canvas';
import { SqlPreviewPanel } from '@/components/visual-schema/sql-preview-panel';
import { AiSchemaAssistant } from '@/components/visual-schema/ai-schema-assistant';
import { AppSidebar } from '@/components/app-sidebar';
import { SidebarProvider, SidebarTrigger } from '@/components/ui/sidebar';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
} from '@/components/ui/breadcrumb';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import {
  ResizableHandle,
  ResizablePanel,
  ResizablePanelGroup,
} from '@/components/ui/resizable';
import { RiDatabase2Line, RiCodeSLine, RiSparklingFill } from '@remixicon/react';

export function VisualSchemaDesignerPage() {
  return (
    <SidebarProvider defaultOpen={false}>
      <AppSidebar />
      <div className="h-screen w-full flex flex-col overflow-hidden">
        {/* Header */}
        <header className="flex h-16 shrink-0 items-center gap-2 border-b px-4">
          <SidebarTrigger className="-ml-1" />
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbPage className="flex items-center gap-2">
                  <RiDatabase2Line className="h-4 w-4" />
                  Visual Schema Designer
                </BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
          <div className="ml-auto flex items-center gap-2">
            <ModeToggle />
          </div>
        </header>

        {/* Main Content */}
        <div className="flex-1 overflow-hidden">
          <ResizablePanelGroup direction="horizontal" className="h-full">
            {/* Schema Canvas */}
            <ResizablePanel defaultSize={65} minSize={40}>
              <ReactFlowProvider>
                <SchemaCanvas />
              </ReactFlowProvider>
            </ResizablePanel>

            <ResizableHandle withHandle />

            {/* Right Panel - SQL Preview & AI Assistant */}
            <ResizablePanel defaultSize={35} minSize={25}>
              <Tabs defaultValue="sql" className="h-full flex flex-col">
                <div className="border-b px-4 pt-2 flex-shrink-0">
                  <TabsList className="grid w-full grid-cols-2 h-9">
                    <TabsTrigger value="sql" className="text-xs gap-2">
                      <RiCodeSLine className="h-3 w-3" />
                      SQL Preview
                    </TabsTrigger>
                    <TabsTrigger value="ai" className="text-xs gap-2">
                      <RiSparklingFill className="h-3 w-3" />
                      AI Assistant
                    </TabsTrigger>
                  </TabsList>
                </div>

                <TabsContent value="sql" className="flex-1 m-0 overflow-hidden">
                  <SqlPreviewPanel />
                </TabsContent>

                <TabsContent value="ai" className="flex-1 m-0 overflow-hidden">
                  <AiSchemaAssistant />
                </TabsContent>
              </Tabs>
            </ResizablePanel>
          </ResizablePanelGroup>
        </div>
      </div>
    </SidebarProvider>
  );
}
